var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C13.6739 8 12.4021 8.52678 11.4645 9.46447C10.5268 10.4021 10 11.6739 10 13V19H12V13C12 12.2043 12.3161 11.4413 12.8787 10.8787C13.4413 10.3161 14.2043 10 15 10C15.7957 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2043 18 13V19H20V13C20 11.6739 19.4732 10.4021 18.5355 9.46447C17.5979 8.52678 16.3261 8 15 8ZM15 6C13.1435 6 11.363 6.7375 10.0503 8.05025C8.7375 9.36301 8 11.1435 8 13V20C8 20.5523 8.44771 21 9 21H13C13.5523 21 14 20.5523 14 20V13C14 12.7348 14.1054 12.4804 14.2929 12.2929C14.4804 12.1054 14.7348 12 15 12C15.2652 12 15.5196 12.1054 15.7071 12.2929C15.8946 12.4804 16 12.7348 16 13V20C16 20.5523 16.4477 21 17 21H21C21.5523 21 22 20.5523 22 20V13C22 11.1435 21.2625 9.36301 19.9497 8.05025C18.637 6.7375 16.8565 6 15 6Z",
    fill: "#12B7A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 7.44772 0.447715 7 1 7H5C5.55228 7 6 7.44772 6 8V20C6 20.5523 5.55228 21 5 21H1C0.447715 21 0 20.5523 0 20V8ZM2 9V19H4V9H2Z",
    fill: "#12B7A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3Z",
    fill: "#12B7A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2bb743a066bffe76207358bd96df7e49.svg";
export { ForwardRef as ReactComponent };